import { Outlet } from 'react-router-dom';
import { AppSidebar } from './AppSidebar';
import { ImpersonationBanner } from './ImpersonationBanner';

export function Layout() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-neutral-50 via-white to-primary-50/30 relative">
      {/* Decorative background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-gradient-to-br from-primary-200/20 to-secondary-200/20 rounded-full blur-3xl" />
        <div className="absolute top-1/2 -left-40 w-80 h-80 bg-gradient-to-br from-secondary-200/20 to-accent-200/20 rounded-full blur-3xl" />
        <div className="absolute -bottom-40 right-1/3 w-80 h-80 bg-gradient-to-br from-accent-200/20 to-primary-200/20 rounded-full blur-3xl" />
      </div>
      <AppSidebar />
      <div className="lg:pl-64">
        <ImpersonationBanner />
        <main className="relative">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
